import React from 'react';
import Reveal from './Reveal';

/**
 * The standard section header: eyebrow -> headline -> supporting description.
 * Used by every redesigned public section so hierarchy reads identically
 * across Services, News and Contact.
 */
const SectionHead = ({ eyebrow, title, lede, align = 'left', className = '' }) => (
  <Reveal className={`ax-head${align === 'center' ? ' ax-head--center' : ''}${className ? ` ${className}` : ''}`}>
    {eyebrow && <span className="ax-eyebrow">{eyebrow}</span>}
    {title && <h2 className="ax-h2">{title}</h2>}
    {lede && <p className="ax-lede">{lede}</p>}
  </Reveal>
);

export default SectionHead;
